const { RESOURCE_TIMING } = require('../../constants/initiatives');

const preparePayload = (_, data) => {
  if (!(data && data.resources && data.resources.length)) {
    return null;
  }

  return {
    name: RESOURCE_TIMING,
    data,
  };
};

module.exports = preparePayload;
